import { render } from "./StaffPage_staffSetting.vue?vue&type=template&id=6ed2cb7c&scoped=true"
import script from "./StaffPage_staffSetting.vue?vue&type=script&lang=js"
export * from "./StaffPage_staffSetting.vue?vue&type=script&lang=js"

import "./StaffPage_staffSetting.vue?vue&type=style&index=0&id=6ed2cb7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed2cb7c"]])

export default __exports__